export default __webpack_public_path__ + "23c1084556bceefbe721fd3d7a3d9cfd.png";